import qs from 'query-string';

/**
 * Parse query
 */
export function parseQueryString(str) {
  return qs.parse(str);
}

/**
 * Build query string from an object
 */
export function buildQueryString(obj) {
  const data = { ...obj };
  const keys = Object.keys(data);

  keys.forEach((key) => {
    if (!data[key] || typeof data[key] !== 'object' || Array.isArray(data[key])) {
      return;
    }

    const innerKeys = Object.keys(data[key]);

    innerKeys.forEach((inner) => {
      data[`${key}[${inner}]`] = data[key][inner];
    });

    delete data[key];
  });

  return qs.stringify(data);
}

/**
 * Parse URL
 */
export function parse(url) {
  const result = {
    url
  };

  const uri = url.split('?');
  result.path = uri.shift();
  result.query = parseQueryString(uri.join('?'));

  // Trim ending slash
  result.path = result.path.replace(/[/]+$/, '') || '/';

  return result;
}
